import { useEventBus } from "../events.mjs";
import { RevokeTokenDocument } from "../../graphql/Auth.mjs";
import { useAppRouter } from "../router.mjs";
import { useStoredUser } from "../auth/storage.mjs";
import { useChannels, topics } from "../channels.mjs";
import { clearSpaCookies } from "../../utils/security.mjs";
import { clearCart } from "../cart/clear-cart.mjs";
import { useMutation } from "villus";
import { useRoute } from "#app";
export function useLogout() {
  const { execute: revokeToken } = useMutation(RevokeTokenDocument.toString());
  const { redirect } = useAppRouter();
  const { push } = useChannels();
  const { user } = useStoredUser();
  const route = useRoute();
  const { emit } = useEventBus();
  function resetUserData() {
    user.value = void 0;
    clearCart();
  }
  function logout() {
    push(topics.auth.logout);
    revokeToken({});
    emit("REVOKE_USER", user.value);
    clearSpaCookies();
    if (/cart/.test(route.fullPath) || /account/.test(route.fullPath) || /order-placed/.test(route.fullPath) || /success/.test(route.fullPath)) {
      redirect("/", {
        // FIXME: using callbacks for now because cannot return promises at the moment
        onComplete: () => {
          resetUserData();
        }
      });
      return;
    }
    resetUserData();
  }
  return {
    logout
  };
}
